import api, { unwrap } from './client';
import type { ApiResponse, PageResponse, SearchParams } from '@/types/api';
import type { StoreRequest, StoreResponse } from '@/types/store';

export const storesApi = {
  list: (params?: SearchParams) =>
    unwrap(api.get<ApiResponse<PageResponse<StoreResponse>>>('/v1/stores', { params })),

  get: (id: number) => unwrap(api.get<ApiResponse<StoreResponse>>(`/v1/stores/${id}`)),

  create: (body: StoreRequest) =>
    unwrap(api.post<ApiResponse<StoreResponse>>('/v1/stores', body)),

  update: (id: number, body: StoreRequest) =>
    unwrap(api.put<ApiResponse<StoreResponse>>(`/v1/stores/${id}`, body)),

  delete: (id: number) => unwrap(api.delete<ApiResponse<null>>(`/v1/stores/${id}`)),

  activate: (id: number, active: boolean) =>
    unwrap(
      api.patch<ApiResponse<StoreResponse>>(`/v1/stores/${id}/activate`, null, {
        params: { active },
      }),
    ),

  getTaxConfig: (storeId: number) =>
    unwrap(api.get<ApiResponse<unknown>>(`/v1/stores/${storeId}/tax-config`)),
};
